import { render, staticRenderFns } from "./facilitiesList.vue?vue&type=template&id=9aaf25b2&"
import script from "./facilitiesList.vue?vue&type=script&lang=js&"
export * from "./facilitiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports